import "./UwMedicalRequest.scss";
import CircularButton, {
  CustomLoadingButton,
  SearchButton,
} from "../../../components/ui/CustomButton";
import newRequest from "../../../utils/newRequest";
import BrokenImageOutlinedIcon from '@mui/icons-material/BrokenImageOutlined';
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import RefreshIcon from "@mui/icons-material/Refresh";
import { FiSearch } from "react-icons/fi";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { motion } from "framer-motion";
import moment from "moment";
import numeral from "numeral";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GridLoader, ScaleLoader } from "react-spinners";
import { IoClose } from "react-icons/io5";
import VideoPlayer from "../../../components/videoPlayer/VideoPlayer";
import { BsFillFileMedicalFill } from "react-icons/bs";



const UwMedicalRequest = () => {
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const [buttonTitle, setButtonTitle] = useState("REFRESH");
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [medicalRequests, setMedicalRequests] = useState([]);

  const fetchMedicalRequests = async () => {
    try {
      setButtonTitle("WORKING...");
      // Simulate delay for 5 seconds
      // await new Promise((resolve) => setTimeout(resolve, 5000));
      const res = await newRequest.post(
        "/uwMedicalRequest/findAll",
        {
          rq_code: "",
          rq_insured_ent_code: "",
          rq_facility_ent_code: "",
          result_limit: 4
        }
      );
      setMedicalRequests(res.data);
      setButtonTitle("REFRESH");
    } catch (error) {
      console.error("Error fetching data:", error);
      setButtonTitle("REFRESH");
    }
  };

  useEffect(() => {
    setIsLoading(true);
    fetchMedicalRequests();
    setIsLoading(false);
  }, []);

  const handleOpenOverlay = () => {
    setIsOverlayOpen(true);
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setPage(0);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const filteredMrequestsData = medicalRequests.filter(
    (item) =>
      item?.rq_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.rq_insured_ent_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.rq_facility_ent_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.rq_insured_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.rq_facility_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const slicedMrequestsData = filteredMrequestsData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleSearchMedicalRequests = async () => {
    try {
      setIsProcessing(true);
      if (searchTerm) {
        const res = await newRequest.post("/uwMedicalRequest/search", { search_input: searchTerm });
        setMedicalRequests(res.data);
      } else {
        fetchMedicalRequests();
      }
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <motion.div
      className="medical-request-home"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      {isLoading ? (
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
        }}
        >
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="medical-request-home-main-wrapper">
          <motion.div className="list-wrapper"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}>
            <div className="list-navbar">
              <div className="list-navbar-left">
                <h1 className="main-title">Requests</h1>
              </div>
              <div className="list-navbar-right">
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="left"
                  endIcon={<RefreshIcon />}
                  onClick={fetchMedicalRequests}>
                  Refresh
                </CustomLoadingButton>
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="right"
                  endIcon={<AddIcon />}
                  onClick={() => {
                    try {
                      navigate(`/medical/new`, {
                        state: null,
                      });
                    } catch (error) {
                      console.log(error)
                    }
                  }}
                >
                  New Request
                </CustomLoadingButton>
              </div>
            </div>
            <div className="list-content">
              <BsFillFileMedicalFill className="icon" />
              <span className="title">Medical Requests</span>
              <p>Welcome to Medical Review Requisitions! Enhance your record management of handling medical requisitions for clients. Simplify interactions with health facilities with accurate and up to date status of each requisition!</p>
              <div className="search-input-wrapper" style={{ width: "70%" }}>
                <FiSearch className="search-input-icon" />
                <input
                  className="search-input"
                  type="text"
                  placeholder="Search documents..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') handleSearchMedicalRequests();
                  }}
                />
                {searchTerm.length > 0 && (
                  <CloseIcon
                    onClick={async (e) => {
                      try {
                        await fetchMedicalRequests();
                        setSearchTerm("");
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    className="search-input-icon"
                  />
                )}
                {searchTerm?.length === 0 && (
                  <span className="search-input-icon" />
                )}
                {/* <SearchButton
                  width={"200px"}
                  themeColor={"#00D37F"}
                  onClick={handleSearchMedicalRequests}>
                  Search
                </SearchButton> */}
              </div>
              <div className="table-content">
                {slicedMrequestsData?.length > 0 &&
                  <div className="table-content">
                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }}
                      className="table-container">
                      <Table sx={{ width: "max-content", border: 'none' }}>
                        <TableBody className="tablebody">
                          {slicedMrequestsData?.map((row, index) => (
                            <TableRow
                              key={row?._id}
                              className="tablerow"
                              onClick={() => {
                                try {
                                  navigate(`/medical/${row?._id}`, {
                                    state: { shouldFetchClients: false },
                                  });
                                } catch (error) {
                                  console.log(error)
                                }
                              }}
                            >
                              <TableCell className="table-cell"
                                style={{
                                  maxWidth: "50px",
                                  alignItems: "center",
                                  justifyContent: "center"
                                }}>
                                {page * rowsPerPage + index + 1}
                              </TableCell>
                              <TableCell className="table-cell" style={{ maxWidth: "100px" }}>
                                <span className="request-no">{row.rq_code}</span>
                              </TableCell>
                              <TableCell className="table-cell" style={{ maxWidth: "35px" }}>
                                {row.insured_details_xx?.ent_photo_url ?
                                  <img src={row.insured_details_xx?.ent_photo_url} alt="" className="entity-img" /> : <BrokenImageOutlinedIcon className="entity-img" />}
                              </TableCell>
                              <TableCell className="table-cell" style={{ maxWidth: "250px" }}>
                                <div className="entity-details">
                                  <h1 className="sub-title">INSURED</h1>
                                  <h1 className="sub-title">{row.insured_details_xx?.ent_name}</h1>
                                </div>
                              </TableCell>
                              <TableCell className="table-cell">
                                <div className="entity-details">
                                  <h1 className="sub-title">FACILITY</h1>
                                  <h1 className="sub-title">{row.facility_details_xx?.ent_name}</h1>
                                </div>
                              </TableCell>
                              <TableCell className="table-cell" style={{ display: "flex", flexDirection: "column", gap: "5px", maxWidth: "100px" }}>
                                {/* <span>{row.bizunit_name_xx}</span> */}
                                <span className={`status ${row.rq_status}`}>{row.rq_status}</span>
                              </TableCell>
                              <TableCell className="table-cell" style={{
                                alignItems: "right",
                                display: "flex",
                                flexDirection: "column",
                                fontSize: "12px",
                                fontWeight: "bold",
                                maxWidth: "250px"
                              }}>
                                <div className="avatar-container">
                                  <div className="left">
                                    <img src={row.updated_by_photo_url_xx} alt="avatar" className="avatar" />
                                  </div>
                                  <div className="right">
                                    <span className="username">{row.updated_by_name_xx}</span>
                                    <span className="time-ago">{row.time_ago_xx}</span>
                                  </div>
                                </div>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      <TablePagination
                        rowsPerPageOptions={[5]}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        component="div"
                        count={filteredMrequestsData.length}
                        page={page}
                        onPageChange={handleChangePage}
                      />
                    </TableContainer>
                  </div>
                }
              </div>
              <div className="list-footer">
                <button className="overlay-button" onClick={handleOpenOverlay}>
                  How it works
                </button>
              </div>
            </div>
          </motion.div>
          {isOverlayOpen && (
            <motion.div
              className="overlay-dialog"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1 } }}
              exit={{ opacity: 0, transition: { duration: 1 } }}
            >
              <div className="overlay-wrapper">
                <div className="overlay-navbar">
                  <span>HELP</span>
                  <span onClick={() => setIsOverlayOpen(false)}>
                    <IoClose
                      style={{
                        width: "30px",
                        height: "30px",
                        cursor: "pointer",
                        borderRadius: "50%",
                      }}
                    />
                  </span>
                </div>
                <div className="overlay-content">
                  <VideoPlayer videoUrl="https://www.youtube.com/embed/PPCfDe8TfJQ" />
                </div>
                <div className="overlay-actions">
                </div>
              </div>
            </motion.div>
          )}
        </div>
      )}

      {
        isProcessing && (
          <motion.div
            className="processing-dialog"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
          >
            <div className="processing-wrapper">
              <GridLoader
                color="#bd97fc"
                style={{
                  height: "50px",
                  width: "50px",
                }}
              />
            </div>
          </motion.div>
        )
      }
    </motion.div>
  );
};

export default UwMedicalRequest;
